import { createComponent } from '@carvana/merch-components';

export const Section = createComponent('section', {
  className: `
    relative
    flex
    min-h-[200px]
    max-w-[1800px]
    flex-col
    gap-y-20
    px-16
    pb-24
    m:gap-y-32
    m:p-32
    l:m-auto
    l:self-center
  `
});

export const TopSection = createComponent('div', {
  className: `flex h-[52px] flex-row m:h-64 l:h-[88px]`
});

export const LeftSection = createComponent('div', {
  className: 'flex w-full flex-col flex-wrap m:w-auto m:grow m:flex-row'
});

export const H4 = createComponent('h4', {
  className: `
    order-1
    h-[44px]
    grow-0
    basis-6/12
    text-[22px]
    font-bold
    capitalize
    leading-6
    tracking-tight
    text-blue-6
    m:shrink-0
    m:grow
    m:basis-full
    m:text-[28px]
    m:leading-8
    l:text-[40px]
    l:leading-[44px]
  `
});

export const RightSection = createComponent('div', {
  className: 'h-56 self-center m:flex m:gap-x-[24px] l:gap-x-[32px]'
});

export const ShareContainer = createComponent('div', {
  className: 'flex min-w-[25px] items-center justify-end'
});

export const Container = createComponent('div', {
  className: `
    order-1
    flex
    basis-6/12
    flex-row
    items-center
    text-sm
    capitalize
    leading-5
    m:basis-auto
    l:text-lg
    l:leading-7
  `
});

export const SuperDialedContainer = createComponent('div', {
  className: `
    order-2
    h-full
    basis-full
    self-end
    text-right
    text-sm
    m:flex
    m:h-auto
    m:w-auto
    m:basis-auto
    m:items-center
    m:self-auto
    m:text-left
    l:text-lg
  `
});

export const SuperDialedWrapper = createComponent('div', {
  className: `
    flex
    h-full
    flex-col
    items-end
    justify-end
    gap-0
    leading-6
    text-grey-5
    m:ml-[9px]
    m:flex-row
    m:items-center
    m:gap-8
    m:border-0
    m:border-l
    m:border-solid
    m:border-grey-2
    m:pl-[11px]
    m:leading-5
    l:ml-20
    l:pl-20
  `
});

export const BottomSection = createComponent('div', {
  className:
    'no-zoom relative grid grid-cols-1 grid-rows-1 overflow-hidden rounded-xl'
});
